<script>
import { matchTime } from '@/mixins/dateMixin';

export default {
  name: 'TimeAutocomplete',
  props: {
    placeholder: { type: String, required: true },
    timeline: { type: Array, required: true },
    value: { type: String, default: '' },
    hideDetails: { type: Boolean, default: false },
  },
  render(createElement) {
    const emitInput = (value) => this.$emit('input', value);
    const emitChange = (value) => this.$emit('change', value);
    const forceUpdate = () => this.$forceUpdate();
    return createElement('v-autocomplete', {
      directives: [
        {
          name: 'mask',
          value: '##:##',
        },
      ],
      on: {
        input: emitInput,
        change: emitChange,
        'update:search-input': function _(selected) {
          forceUpdate(); // prevents freezing of vuetify v-text-field
          (Array.isArray(selected) ? selected : Array(selected))
            .flatMap(matchTime([]))
            .forEach(emitInput);
        },
      },
      props: {
        itemText: 'title',
        itemValue: 'title',
        items: this.timeline,
        menuProps: {
          closeOnContentClick: true,
        },
        noDataText: 'Результатов нет',
        hideDetails: this.hideDetails,
        placeholder: this.placeholder,
        value: this.value,
      },
    });
  },
};
</script>
